// TODO: Write tests for this file

import React from "react";
import { GKContent, Container } from "@granular/gds-ux-components";

import { useFabricDepCheck } from "../../../hooks/deps";
import { useLogAppVersion } from "../../../hooks/version";

import { DOCS_ID } from "./constants";
import {
  DynamicDocsImports,
  useDynamicDocs,
  useScrollToTopOnPathnameChange,
} from "./helpers";
import { FederatedModulesDocsHelmet } from "./DocsHelmet";
import { FederatedModulesDocsAppRouter } from "./DocsAppRouter";
import { FederatedModulesDocsAppSelect } from "./DocsAppSelect";

export type FederatedModulesDocsAppProps = {
  env: typeof process.env;
  imports: DynamicDocsImports;
};

const GK_CONTENT_ID = `${DOCS_ID}--content`;

export const FederatedModulesDocsApp: React.FC<FederatedModulesDocsAppProps> =
  ({ env, imports }) => {
    useLogAppVersion(env);
    useFabricDepCheck(env);
    useScrollToTopOnPathnameChange(GK_CONTENT_ID);

    const dynamicDocs = useDynamicDocs({ imports });

    return (
      <GKContent id={GK_CONTENT_ID}>
        <FederatedModulesDocsHelmet />
        <Container className="my-3">
          <FederatedModulesDocsAppSelect dynamicDocs={dynamicDocs} />
          <FederatedModulesDocsAppRouter dynamicDocs={dynamicDocs} />
        </Container>
      </GKContent>
    );
  };
